import { TreeItemModel } from '../TreeItemModel';

export interface IAlertInfo extends TreeItemModel<IAlertInfo>
{
    id: number;
}

export interface IConstantAlertIds
{ 
    All: number, 
    FrontOffice: number
};

export const constantAlertIds: IConstantAlertIds = {
        All: 999,
        FrontOffice: 220
};


export interface IAlertTreeOptionModel extends TreeItemModel<IAlertTreeOptionModel>
{
    id: number, 
    selected?: boolean
}
